// Copyright 2021 The Casdoor Authors. All Rights Reserved.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

import React from "react";
import {Button, Spin} from "antd";
import i18next from "i18next";
import {authConfig} from "./Auth";
import * as ApplicationBackend from "../backend/ApplicationBackend";
import * as Setting from "../Setting";
import * as AuthBackend from "./AuthBackend";
import {CheckCircleFilled} from "@ant-design/icons";
import CustomGithubCorner from "../common/CustomGithubCorner";

class ResultPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      classes: props,
      applicationName: props.match.params.applicationName !== undefined ? props.match.params.applicationName : authConfig.appName,
      application: null,
    };
  }

  componentDidMount() {
    document.documentElement.classList.add("auth-modern-login-page");
    document.body.classList.add("auth-modern-login-page");

    if (this.state.applicationName !== undefined) {
      this.getApplication();
    } else {
      Setting.showMessage("error", `${i18next.t("general:Unknown application name")}: ${this.state.applicationName}`);
    }
  }

  componentWillUnmount() {
    document.documentElement.classList.remove("auth-modern-login-page");
    document.body.classList.remove("auth-modern-login-page");
  }

  getApplication() {
    if (this.state.applicationName === undefined) {
      return;
    }

    ApplicationBackend.getApplication("admin", this.state.applicationName)
      .then((res) => {
        if (res.status === "error") {
          Setting.showMessage("error", res.msg);
          return;
        }

        this.onUpdateApplication(res.data);
        this.setState({
          application: res.data,
        });
      });
  }

  onUpdateApplication(application) {
    this.props.onUpdateApplication(application);
  }

  handleSignIn = () => {
    AuthBackend.getAccount()
      .then((res) => {
        if (res.status === "ok" && res.data) {
          const linkInStorage = sessionStorage.getItem("signinUrl");
          if (linkInStorage !== null && linkInStorage !== "") {
            window.location.href = linkInStorage;
          } else {
            Setting.goToLink("/");
          }
        } else {
          Setting.redirectToLoginPage(this.state.application, this.props.history);
        }
      });
  };

  render() {
    const application = this.state.application;

    if (application === null) {
      return (
        <div className="auth-modern-result-loading">
          <Spin size="large" tip={i18next.t("login:Loading")} />
        </div>
      );
    }

    return (
      <React.Fragment>
        <CustomGithubCorner />
        <div className="login-content auth-screen auth-screen--result">
          <div className={Setting.isDarkTheme(this.props.themeAlgorithm) ? "login-panel-dark auth-panel auth-result-panel" : "login-panel auth-panel auth-result-panel"}>
            <div className="login-form auth-form auth-result-form">
              <div className="auth-modern-result-hero">
                {Setting.renderHelmet(application)}
                <div className="auth-modern-result-logo-wrap">
                  {Setting.renderLogo(application)}
                </div>
              </div>

              <div className="auth-modern-result-icon-wrap">
                <CheckCircleFilled className="auth-modern-result-icon" />
              </div>

              <h1 className="auth-modern-result-title">{i18next.t("signup:Your account has been created!")}</h1>
              <p className="auth-modern-result-subtitle">{i18next.t("signup:Please click the below button to sign in")}</p>

              <Button type="primary" className="auth-modern-result-button" onClick={this.handleSignIn}>
                {i18next.t("login:Sign In")}
              </Button>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default ResultPage;
